'use strict';

var _ = require('lodash');

_.extend(
  module.exports,
  require('./resize'),
  {
    supports: require('./supports')
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/scripts/services/utils/dom/index.js
// module id = 187
// module chunks = 0